import * as React from "react"

class Loader extends React.Component {
  render() {
    return (
      	<svg className="loader-icon is-rotating" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M18.92,12.92l-7.27-2.94l7.27-2.94c0.55-0.22,0.75-0.91,0.44-1.5l-0.31-0.59c-0.32-0.59-1.02-0.8-1.51-0.46 l-6.48,4.63l0.93-7.92c0.07-0.59-0.44-1.1-1.1-1.1l-0.67-0.01C9.55,0.11,9.02,0.62,9.1,1.22l0.96,7.94L3.55,4.51 c-0.49-0.35-1.2-0.14-1.51,0.46L1.72,5.55c-0.31,0.58-0.11,1.28,0.44,1.5l7.27,2.94l-7.27,2.94c-0.55,0.22-0.75,0.91-0.44,1.5 l0.31,0.59c0.32,0.59,1.02,0.81,1.51,0.46l6.48-4.63l-0.93,7.92c-0.07,0.59,0.44,1.1,1.1,1.1l0.67,0.01 c0.67,0.01,1.2-0.51,1.13-1.11l-0.96-7.94l6.51,4.65c0.49,0.35,1.19,0.14,1.51-0.46l0.31-0.59C19.67,13.84,19.47,13.14,18.92,12.92z" fill="#FFFFE7" />
		</svg>  
    )
  }
} 

export default Loader

